module.exports = __webpack_public_path__ + "img/ppt.e278666a.png";